import DataQuery from "data/DataQuery";
import { Contract_Consumption } from "data/endpoints";
import { useQuery } from "data/hooks/useQuery";
import MeasuredDataResultDTO from "features/shared/dtos/MeasuredDataResultDTO";
import { getConsumptionParams } from "features/shared/helpers/queryParams";
import { getRouteParams } from "features/shared/helpers/routeParams";
import React from "react";
import { isEmpty } from "features/shared/helpers/objects";
import ContractFullDTO from "../dtos/ContractFullDTO";
import Alert from "features/shared/alerts/components/Alert";
import { useTranslation } from "react-i18next";
import MeasuredDataGraphCard from "features/shared/components/graphs/MeasuredDataGraphCard";
interface Props {
  contract: ContractFullDTO;
  meterType: string;
}

const ConsumptionHistorySection = ({ contract, meterType }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  // fetch data
  // real consumption
  const realConsumptionQuery: DataQuery = {
    url: Contract_Consumption,
    routeParams: getRouteParams("contractId", contract.contractId!),
    params: getConsumptionParams("Real", undefined, undefined, contract.isProduction)
  };
  const { data: realConsumption, loadStatus: realConsumptionStatus } = useQuery<MeasuredDataResultDTO>(realConsumptionQuery, {measuredValues: []});
  
  // plan consumption
  const planConsumptionQuery: DataQuery = {
    url: Contract_Consumption,
    routeParams: getRouteParams("contractId", contract.contractId!),
    params: getConsumptionParams("Plan", undefined, undefined, contract.isProduction)
  };
  const { data: planConsumption, loadStatus: planConsumptionStatus } = useQuery<MeasuredDataResultDTO>(planConsumptionQuery, {});

  // helpers
  const hasData = (): boolean => {
    if (!isEmpty(realConsumption) && !isEmpty(planConsumption) && isLoaded()) {
      return true;
    }

    return false;
  };

  const isLoaded = (): boolean => {
    if (realConsumptionStatus === "AfterFirstLoad" && planConsumptionStatus === "AfterFirstLoad")  {
      return true;
    }

    return false;
  }

  // subr-renders
  const renderAdditionalInfo = () => { 
    let label = tLabels("consumptionHistorySection.productionAdditionalInfo");

    if (contract.isProduction && label !== "") {
      return (
        <p className="mt-2 mb-1 mb-0 small text-muted font-italic">
          {label}
        </p>
      );
    } 

    return <></>;
  }

  // render
  if (hasData()) {
    return (
      <MeasuredDataGraphCard 
        commodityDetail={contract.commodityDetail!}
        realValues={realConsumption}
        planValues={contract.isProduction ? undefined : planConsumption}
        showLegend
        adaptiveContainerHeight={
          contract.contractType !== "ElectricityHighVoltage" &&
          contract.contractType !== "GasLargeConsumption" &&
          !(contract.contractType === "ElectricityLowVoltage" &&
          meterType === "B" &&
          contract.isProduction === true)
        }
        isProduction={contract.isProduction}
        renderAdditionalInfo={renderAdditionalInfo}  
      />
    );
  } else if (isLoaded()) {
    return <Alert alertObj={{ alertType: "Info", message: tLabels("consumptionHistorySection.dataNotFound")}} />;
  } else {
    return <></>
  }
};

export default ConsumptionHistorySection;
